import { render, staticRenderFns } from "./AddInvoicePage.vue?vue&type=template&id=0cff7685&scoped=true&"
import script from "./AddInvoicePage.vue?vue&type=script&lang=js&"
export * from "./AddInvoicePage.vue?vue&type=script&lang=js&"
import style0 from "./AddInvoicePage.vue?vue&type=style&index=0&id=0cff7685&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cff7685",
  null
  
)

export default component.exports